import { apiFetch } from '@m/utils/http';

/**
 * @deprecated use @m/hooks/data/featureFlags instead or @m/services/experimentation/FeatureFlagService if not in a react component.
 */
export const FeatureFlagService = {
  /**
   * Fetch available feature flags
   */
  getFeatureFlags: () => apiFetch('/admin/feature'),

  /**
   * Get feature flag setting - requires super admin permissions
   */
  getFeatureFlagSetting: ({ name }: { name: string }) => apiFetch(`/admin/feature/${name} `),

  /**
   * Get specific feature flag setting
   * TODO: make this route non customer app related?
   */
  getFeatureFlagSettingCustomer: ({
    name,
    siteId,
    enterpriseId,
  }: {
    enterpriseId?: number;
    name: string;
    siteId?: number;
  }) =>
    apiFetch<boolean>(`/customer/feature/${name}`, {
      params: {
        siteId,
        enterpriseId,
      },
    }),

  /**
   * Update a feature flag setting
   */
  setFeatureFlagSetting: ({
    name,
    enabled,
    sites,
    siteUuids,
    enterprises,
  }: {
    enabled: boolean;
    enterprises?: number[];
    name: string;
    sites?: number[];
    siteUuids?: string[];
  }) =>
    apiFetch(`/admin/feature/${name}`, {
      method: 'POST',
      body:
        (sites && sites.length > 0) || (enterprises && enterprises.length > 0)
          ? {
              ...(sites ? { sites } : {}),
              ...(siteUuids ? { siteUuids } : {}),
              ...(enterprises ? { enterprises } : {}),
            }
          : { enabled },
    }),

  /**
   * Archive feature flag
   */
  archiveFeatureFlag: ({ name }: { name: string }) =>
    apiFetch(`/admin/feature/${name}`, { method: 'DELETE' }),

  /**
   * Create new feature flag
   */
  createFeatureFlag: ({
    name,
    enabled,
    sites,
  }: {
    enabled?: boolean;
    name: string;
    sites?: number[];
  }) =>
    apiFetch(`/admin/feature/${name}`, {
      method: 'POST',
      body: sites ? { sites } : { enabled },
    }),
};
